import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PerformanceCounterType } from './performance-counter-type.interface';
import { PerformanceCounterTypeService } from './performance-counter-type.service';

const service = new PerformanceCounterTypeService();

export interface PerformanceCounterTypeState {
   performanceCounterTypes: Array<PerformanceCounterType>;
}

const PerformanceCounterTypeStore: Module<PerformanceCounterTypeState, StoreState> = {
   namespaced: true,
   state: {
      performanceCounterTypes: [],
   },
   getters: {
      performanceCounterTypes: (state) => {
         return state.performanceCounterTypes;
      },
   },
   mutations: {
      SET_PERFORMANCE_COUNTER_TYPES(state, performanceCounterTypes: Array<PerformanceCounterType>) {
         state.performanceCounterTypes = performanceCounterTypes;
      },
   },
   actions: {
      async getPerformanceCounterTypes(context) {
         return await service.getPerformanceCounterTypes().then((response) => {
            context.commit('SET_PERFORMANCE_COUNTER_TYPES', response.data);
            return response.data;
         });
      },
   },
};

export default PerformanceCounterTypeStore;
